import CountUp from "react-countup";

function SectionCounter1() {
  return (
    <>
      <div className="counter-blocks">
        <div className="row when-item-four">
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
            <div className="sx-count">
              <h2 className="sx-title"><span className="counter"><CountUp end={8} duration={8} /></span><span className="sx-cont-after">+</span></h2>
              <div className="sx-count-info">Years of Regional Operations</div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
            <div className="sx-count">
              <h2 className="sx-title"><span className="counter"><CountUp end={20} duration={8} /></span><span className="sx-cont-after">+</span></h2>
              <div className="sx-count-info">Corporate Client Engagements</div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
            <div className="sx-count">
              <h2 className="sx-title"><span className="counter"><CountUp end={6} duration={8} /></span><span className="sx-cont-after">+</span></h2>
              <div className="sx-count-info">Core Specialist Service Areas</div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
            <div className="sx-count">
              <h2 className="sx-title"><span className="counter"><CountUp end={24} duration={8} /></span><span className="sx-cont-after">/7</span></h2>
              <div className="sx-count-info">Operational Readiness</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SectionCounter1;
